module.exports = __webpack_public_path__ + "img/58.256f3a64.jpg";